var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        {
          style: _vm.addCampaignClass
        },
        [
          _c(
            "v-col",
            {
              staticClass: "text-right py-0",
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    color: "primary",
                    tile: ""
                  },
                  on: {
                    click: _vm.openAddCampaign
                  }
                },
                [_vm._v(" Add Campaign ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-card",
                [
                  _c("gg-card-header", [
                    _vm._v(" Affiliate Campaign Instructions ")
                  ]),
                  _c("gg-card-text", [
                    _c(
                      "div",
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    " Campaigns will allow you to create unique codes that you can use to identify specific marketing initatives, sites or projects to allow you to convert better. "
                                  )
                                ]),
                                _c("span", [
                                  _vm._v(
                                    " Click the link below to Add a Campaign Code. "
                                  )
                                ])
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "pb-0",
                                attrs: {
                                  cols: "12",
                                  md: "6"
                                }
                              },
                              [_c("h4", [_vm._v("Your Campaigns")])]
                            ),
                            _c(
                              "v-col",
                              {
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("gg-text-field", {
                                  attrs: {
                                    "hide-details": "",
                                    placeholder: "Search"
                                  },
                                  model: {
                                    value: _vm.search,
                                    callback: function callback($$v) {
                                      _vm.search = $$v
                                    },
                                    expression: "search"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("v-data-table", {
                                  attrs: {
                                    headers: _vm.headers,
                                    items: _vm.campaigns,
                                    search: _vm.search,
                                    loading: _vm.pending
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "item.actions",
                                      fn: function fn(_ref) {
                                        var item = _ref.item
                                        return [
                                          _c(
                                            "v-menu",
                                            {
                                              attrs: {
                                                "offset-y": ""
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function fn(_ref2) {
                                                      var on = _ref2.on,
                                                        attrs = _ref2.attrs
                                                      return [
                                                        _c(
                                                          "gg-btn",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "primary",
                                                                  icon: ""
                                                                }
                                                              },
                                                              "gg-btn",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "mdi-dots-vertical"
                                                              )
                                                            ])
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _c(
                                                "v-list",
                                                [
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      on: {
                                                        click: function click(
                                                          $event
                                                        ) {
                                                          return _vm.triggerEditDescription(
                                                            item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-list-item-title", [
                                                        _vm._v(" Edit ")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.addDialog
        },
        on: {
          close: _vm.closeAddCampaign
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [_vm._v(" Create Campaign ")]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _c("p", [
                  _vm._v(
                    "To create your campaign codes, simply enter an alpha-numeric code (no special characters allowed) in the Campaign Code field."
                  )
                ]),
                _vm._v(
                  " You will also be able to enter a description to help you identify your campaigns later on. Once you're satisfied, click on "
                ),
                _c("b", [_vm._v("Save Changes")]),
                _vm._v(". "),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12",
                          sm: "4"
                        }
                      },
                      [
                        _c("gg-text-field", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            label: "Campaign Code",
                            "data-vv-name": "campaign_code",
                            "data-vv-as": "Campaign Code",
                            "error-messages": _vm.errors.collect(
                              "campaign_code"
                            )
                          },
                          model: {
                            value: _vm.model.add.campaign_code,
                            callback: function callback($$v) {
                              _vm.$set(_vm.model.add, "campaign_code", $$v)
                            },
                            expression: "model.add.campaign_code"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12",
                          sm: "8"
                        }
                      },
                      [
                        _c("gg-text-field", {
                          attrs: {
                            label: "Description"
                          },
                          model: {
                            value: _vm.model.add.campaign_description,
                            callback: function callback($$v) {
                              _vm.$set(
                                _vm.model.add,
                                "campaign_description",
                                $$v
                              )
                            },
                            expression: "model.add.campaign_description"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      secondary: ""
                    },
                    on: {
                      click: _vm.closeAddCampaign
                    }
                  },
                  [_vm._v("Close")]
                ),
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      primary: "",
                      loading: _vm.newCampaignPending
                    },
                    on: {
                      click: _vm.addCampaign
                    }
                  },
                  [_vm._v("Save Changes")]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.editDialog
        },
        on: {
          close: _vm.triggerEditDescription
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [_vm._v(" Edit Campaign Description ")]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _c("p", [_vm._v(" Edit campaign description ")]),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c("gg-text-field", {
                          attrs: {
                            label: "Description"
                          },
                          model: {
                            value: _vm.model.edit.value,
                            callback: function callback($$v) {
                              _vm.$set(_vm.model.edit, "value", $$v)
                            },
                            expression: "model.edit.value"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      secondary: ""
                    },
                    on: {
                      click: _vm.triggerEditDescription
                    }
                  },
                  [_vm._v("Close")]
                ),
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      primary: "",
                      loading: _vm.editPending
                    },
                    on: {
                      click: _vm.editDescription
                    }
                  },
                  [_vm._v("Save Changes")]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }